/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AgingRule } from '../models/AgingRule';
import type { AgingRuleExportResponse } from '../models/AgingRuleExportResponse';
import type { AgingRuleUpdate } from '../models/AgingRuleUpdate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AgingRuleService {

    /**
     * Update Aging Rule
     * @returns AgingRule Success
     * @throws ApiError
     */
    public static updateAgingRules({
        requestBody,
    }: {
        requestBody: Array<AgingRule>,
    }): CancelablePromise<Array<AgingRule>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/aging',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export aging rules
     * Schedules an Excel (.xlsx) export of every aging rule of the company with its
     * criteria, periods and factors. The file appears on the Downloads page when it is ready.
     *
     * @returns AgingRuleExportResponse Export scheduled
     * @throws ApiError
     */
    public static exportAgingRules(): CancelablePromise<AgingRuleExportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aging/export',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Get Aging Rule
     * @returns AgingRule Success
     * @throws ApiError
     */
    public static getAgingRule(): CancelablePromise<Array<AgingRule>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aging/rule',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create Aging Rule
     * @returns any Success
     * @throws ApiError
     */
    public static createAgingRule({
        requestBody,
    }: {
        requestBody: Record<string, any>,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aging/rule',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Aging Rule
     * @returns AgingRuleUpdate Success
     * @throws ApiError
     */
    public static updateAgingRule({
        id,
        requestBody,
    }: {
        /**
         * Custom Percentile ID
         */
        id: number,
        requestBody?: AgingRule,
    }): CancelablePromise<AgingRuleUpdate> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/aging/rule/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Aging Rule
     * @returns any Success
     * @throws ApiError
     */
    public static deleteAgingRule({
        id,
    }: {
        /**
         * Custom Percentile ID
         */
        id: number,
    }): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/aging/rule/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
